import { useLocation } from "react-router-dom";
import BottomNavigationItem from "./BottomNavigationItem";
import "./bottomNavigation.scss";

const ICON_PROPS = {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: false,
};

function NotificationsIcon() {
  return (
    <svg {...ICON_PROPS}>
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}

function CarsIcon() {
  return (
    <svg {...ICON_PROPS}>
      <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" />
      <circle cx="7" cy="17" r="2" />
      <path d="M9 17h6" />
      <circle cx="17" cy="17" r="2" />
    </svg>
  );
}

function HomeIcon() {
  return (
    <svg {...ICON_PROPS}>
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <path d="M9 22V12h6v10" />
    </svg>
  );
}

function RegisterServiceIcon() {
  return (
    <svg {...ICON_PROPS}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 8v8" />
      <path d="M8 12h8" />
    </svg>
  );
}

function ProfileIcon() {
  return (
    <svg {...ICON_PROPS}>
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

// Route for the notifications page (due service reminders).
export const NOTIFICATIONS_ROUTE = "/notifications";

// Single source of truth for the 5 tabs, in the required order:
// اعلان‌ها | ماشین‌ها | ثبت سرویس | خانه | پروفایل (RTL: first item is rightmost).
// Icon-only by design; Persian names live in aria-label/title only.
// The notifications entry navigates to the notifications page backed by
// GET /reminders/due (due service reminders).
// The register-service entry navigates to the existing registration flow
// entry (/SelectService) and stays active across the whole flow
// (/SelectService, /ServiceOne, /ServiceTwo, /ServiceThree, /Periodic/*).
const NAV_ITEMS = [
  {
    key: "notifications",
    to: NOTIFICATIONS_ROUTE,
    disabled: false,
    label: "اعلان‌ها",
    title: "اعلان‌ها",
    Icon: NotificationsIcon,
    isActive: (pathname) => pathname.startsWith(NOTIFICATIONS_ROUTE),
  },
  {
    key: "cars",
    to: "/Cars",
    label: "ماشین‌ها",
    title: "ماشین‌ها",
    Icon: CarsIcon,
    isActive: (pathname) =>
      pathname === "/Cars" || pathname.startsWith("/AddCars"),
  },
  {
    key: "register-service",
    to: "/SelectService",
    label: "ثبت سرویس",
    title: "ثبت سرویس",
    Icon: RegisterServiceIcon,
    isActive: (pathname) =>
      pathname.startsWith("/SelectService") ||
      pathname.startsWith("/ServiceOne") ||
      pathname.startsWith("/ServiceTwo") ||
      pathname.startsWith("/ServiceThree") ||
      pathname.startsWith("/Periodic"),
  },
  {
    key: "home",
    to: "/",
    label: "خانه",
    title: "خانه",
    Icon: HomeIcon,
    isActive: (pathname) => pathname === "/",
  },
  {
    key: "profile",
    to: "/UserPanel",
    label: "پروفایل",
    title: "پروفایل",
    Icon: ProfileIcon,
    isActive: (pathname) => pathname.startsWith("/UserPanel"),
  },
];

function BottomNavigation() {
  const { pathname } = useLocation();

  return (
    <>
      {/* In-flow spacer: reserves the fixed bar's height so page
          content is never covered and no extra scroll is created. */}
      <div className="bottom-nav-spacer" aria-hidden="true" />
      <nav className="bottom-nav" dir="rtl" aria-label="ناوبری اصلی" data-testid="bottom-nav">
        <ul className="bottom-nav__list">
          {NAV_ITEMS.map((item) => (
            <BottomNavigationItem
              key={item.key}
              itemKey={item.key}
              to={item.to}
              label={item.label}
              title={item.title}
              Icon={item.Icon}
              active={item.isActive(pathname)}
              disabled={item.disabled}
            />
          ))}
        </ul>
      </nav>
    </>
  );
}

export default BottomNavigation;
export { NAV_ITEMS };
export {
  NotificationsIcon,
  CarsIcon,
  HomeIcon,
  RegisterServiceIcon,
  ProfileIcon,
};
